import { Quote } from '@/modules/Quote/interfaces/quote'
import { User } from '@/modules/User/interfaces/user'
import { LienHolder } from '@/modules/LienHolder/interfaces/lien-holder'
import { Policy } from '@/modules/Policy/interfaces/policy'

export enum VehicleCoverage {
  NONE = '--None--',
  COMPREHENSIVE_AND_COLLISION = 'Comprehensive and Collision',
  COMPREHENSIVE_ONLY = 'Comprehensive only',
  LIABILITY_ONLY = 'Liability Only',
}

export interface Vehicle {
  id: number;
  name: string;
  vin: string;
  year: string;
  make: string;
  loan: boolean;
  model: string;
  notes: string;
  vehicleCoverage: VehicleCoverage;
  roadsideTowing: boolean;
  rentalCarCoverage: boolean;
  createdAt: string;
  updatedAt: string;
  lastModifiedBy: User;
  createdBy: User;
  quote: Quote
  policy: Policy
  lienHolder: LienHolder
  ownership: VehicleOwnership
  mileage: string
  useage: VehicleUseage
}

// """Vehicle Ownership"""
export enum VehicleOwnership {
  OWN = 'OWN',
  FINANCE = 'FINANCE',
  LEASE = 'LEASE',
}

// """Vehicle Useage"""
export enum VehicleUseage {
  PLEASURE = 'PLEASURE',
  COMMUTE = 'COMMUTE'
}
